import React from 'react';
import './success.css';

const SuccessStories = () => {
  return (
    <div className="stories-container">
      <header className="stories-header">
        <h1>Success Stories of Your Contributions</h1>
        <p>E-Techno Educational and Research Society</p>
      </header>

      <section className="stories-section">
        <p>
          At E-Techno Educational and Research Society, your donations have played a pivotal role in creating meaningful change. Here are some of the successes your support has made possible:
        </p>

        <div className="stories-item">
          <h2>Bridging the Education Gap</h2>
          <p>
            We have successfully provided educational materials, scholarships, and digital learning tools to underprivileged students, ensuring they have equal opportunities to succeed.
          </p>
        </div>

        <div className="stories-item">
          <h2>Advancing Research Initiatives</h2>
          <p>
            Your contributions have funded research projects addressing critical social, environmental, and technological challenges, fostering innovation for a better future.
          </p>
        </div>

        <div className="stories-item">
          <h2>Empowering Communities</h2>
          <p>
            Through skill-building workshops and community development programs, we have equipped individuals with the tools they need to improve their lives and contribute positively to society.
          </p>
        </div>

        <div className="stories-item">
          <h2>Building a Sustainable Future</h2>
          <p>
            We've launched initiatives to promote sustainability and awareness, shaping a more informed and responsible generation.
          </p>
        </div>

        <p>
          Each donation brings us closer to realizing our vision of a world driven by education and research. Thank you for being an essential part of our journey toward success! Together, we’re creating a brighter tomorrow.
        </p>
      </section>

      <footer className="stories-footer">
        <p>&copy; 2024 E-Techno Educational and Research Society. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default SuccessStories;
